import React, { Component } from 'react';
import { Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { updateInPath, logError, logMessage } from '../../../common/utils';
import MyAuth from '../../components/Auth'; 


class CustomAuthenticator extends Component {
  constructor(props) {
    super();

    this.state = {
      showConfirmationCode: false,
      error: '',
      success: '',
      // TODO: HACK!
      oldPwd: ''
    };

    // all auth screens share same error/succes message
    // from the state of this container.
    // clear error messages on route update so that
    // they would not carry over to next view
    props.history.listen(this.clearErrors);
  }

  handleTabChange = (e, { activeIndex }) => {
    if (activeIndex === 0) {
      this.props.history.push('/signin');
    } else {
      this.props.history.push('/signup');
    }
  };

  // TODO afterSignInRouting based on Role!
  signIn = (username, password) => {
    Auth.signIn(username, password)
      .then(user => {
        if (!user.challengeName) {
          this.props.history.push('/my');
          this.setState(prevState => updateInPath(prevState, 'success', 'create_account_success'));
        } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.props.history.push('/signup');
          this.setState(prevState => updateInPath(prevState, 'oldPwd', password));
          this.setState(prevState => updateInPath(prevState, 'success', username));
        } else {
          logError(user);
        }
        
      })
      .catch(this.cognitoErrorHandler);
  }

  handleCompleteNewPassword = (username, newPwd, attr) => {
    // TODO: this oldPwd is a hack!
    Auth.signIn(username, this.state.oldPwd)
      .then(user => {
        Auth.completeNewPassword(user, newPwd, attr)
          .then(() => {
            this.props.history.push('/my');
          })
          .catch(this.cognitoErrorHandler);
      })
      .catch(this.cognitoErrorHandler);
  }

  handleForgotPassword = (username) => {
    console.log(username);
    Auth.forgotPassword(username)
      .then(data => {
        this.setState(prevState => {
          this.props.history.push('/resetpassword');
          this.clearErrors();
        });
      })
      .catch(this.cognitoErrorHandler);
  }

  handleResetPassword = (username, code, password) => {
    Auth.forgotPasswordSubmit(username, code, password)
      .then(data => {
        this.setState(prevState => {
          this.props.history.push('/signin');
          this.clearErrors();
          return updateInPath(prevState, 'success', 'pwd_change__success');
        });
      })
      .catch(this.cognitoErrorHandler);
  }

  signUp = (username, password, attributes) => {
    Auth.signUp({
      username,
      password,
      attributes: attributes
    })
      .then(data => this.props.history.push('/confirm'))
      .catch(this.cognitoErrorHandler);
  }

  confirmSignUp = (username, code) => {
    Auth.confirmSignUp(username, code)
      .then(data => {
        this.setState(prevState => {
          this.props.history.push('/signin');
          this.clearErrors();
          return updateInPath(prevState, 'success', 'create_account_success');
        });

      })
      .catch(this.cognitoErrorHandler);
  }

  resendCode = (username) => {
    if (!username) {
      this.setState(prevState => {
        return updateInPath(prevState, 'error', 'EmailMissing');
      });
      return;
    }
    
    Auth.resendSignUp(username)
      .then(data => {
        this.setState(prevState => {
          this.clearErrors();
          return updateInPath(prevState, 'success', 'code_resend_success');
        });

      })
      .catch(this.cognitoErrorHandler);    
  }

  clearErrors = () => {
    this.setState(prevState => updateInPath(prevState, 'error', ''));
    this.setState(prevState => updateInPath(prevState, 'success', ''));
  }

  // TODO separate exceptionHandler
  cognitoErrorHandler = (err) => {
    const { code } = err;

    console.log(err);

    this.setState(prevState => updateInPath(prevState, 'error', code));
    
    if (code === 'InvalidParameterException') {
      logMessage(err);
    }  else if (code === 'UserNotConfirmedException') {
      // TODO this is not perfect here
      // it should get triggered from SignUp!
      this.props.history.push('/confirm');
    }
  }

  render () {
    const { history, user } = this.props;

    return (
      !user &&
        <MyAuth
          route={history.location.pathname}
          onTabChange={this.handleTabChange}
          onSignIn={this.signIn}
          onSignUp={this.signUp}
          onConfirmSignUp={this.confirmSignUp}
          onForgotPassword={this.handleForgotPassword}
          onResetPassword={this.handleResetPassword}
          onResendCode={this.resendCode}
          error={this.state.error}
          success={this.state.success}
          showConfirmationCode={this.state.showConfirmationCode}
          onChangePassword={this.handleCompleteNewPassword}
        />
    );
  };
}

export default withRouter(CustomAuthenticator);



// WEBPACK FOOTER //
// ./src/public/containers/Auth/index.js